import Image from "next/image";
import { motion } from "framer-motion";

type ProductSectionProps = {
  title: string;
  faTitle: string;
  showFa: boolean;
  open: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  dir?: "ltr" | "rtl";
  textAlign?: "left" | "justify";
  invalid?: boolean;
};

export default function ProductSection({
  title,
  faTitle,
  showFa,
  open,
  onToggle,
  children,
  dir = "ltr",
  textAlign = "left",
  invalid = false,
}: ProductSectionProps) {
  return (
    <div dir={dir} className={`bg-grayCustom lg:bg-white lg:px-0 px-4 py-1 text-${textAlign}`}>
      <motion.div
        layout
        transition={{ duration: 0.3 }}
        className={`px-4 rounded-md bg-white overflow-hidden border ${
          invalid ? "border-red-500 ring-1 ring-red-300" : "border-gray-200"
        }`}
      >
        <div
          className="cursor-pointer flex justify-between items-center"
          onClick={onToggle}
        >
          <h3 className="py-2 text-xl font-bold relative">
            {showFa ? faTitle : title}
          </h3>

          <motion.div
            animate={{ rotate: showFa ? (open ? 90 : 180) : open ? 90 : 0 }}
            transition={{ duration: 0.2 }}
          >
            <Image
              src={"/assets/images/arrow_blue.svg"}
              alt="toggle"
              width={10}
              height={10}
            />
          </motion.div>
        </div>
        <motion.div
          initial={false}
          animate={{
            height: open ? "auto" : 0,
            opacity: open ? 1 : 0,
          }}
          transition={{ duration: 0.2 }}
        >
          <div className="space-y-4 pb-3">{children}</div>
        </motion.div>
      </motion.div>
    </div>
  );
}
